import axios from 'axios';

export const postLogin = async (username: string, password: string) => {
  const BACKEND_API = process.env.REACT_APP_BACKEND_BASE!;
  const api = `${BACKEND_API}token`;
  const data = await axios.post(api, { username, password });
  return data.data;
};
